import { LiveApi, RoomInfo, UserInfo } from "./interface";
import { querySearchParam } from "@/utils/basic";
import  api  from "@/utils/api";
let userInfo: UserInfo;
let roomInfo: RoomInfo;

/**
 * 访客模式获取用户信息和直播间信息
 */
const visitLoginAuth = async () => {
  let roomId = querySearchParam('roomId');
  const { result } = await api.post('/glive2-cloud-gateway/api/v1/live/room/loginAuthVisit', { roomId });
  if(result){
    userInfo  = { user: result.userInfo, streamId: roomId || '' };
    roomInfo = result.roomInfo;
  }
  
}
export const liveBot: LiveApi = {
  getLiveToken: () => Promise.resolve({}),
  getUserInfo: async () => {
    await visitLoginAuth();
    if(userInfo){
      return Promise.resolve({
        result: {
          user: userInfo.user,
          streamId:''
        },
      })
    }
    return Promise.resolve({})
    
  },
  getRoomInfo: () =>
    Promise.resolve({
      result: roomInfo,
    }),
  getUserRoomInfo:(roomId) => api.get(`/glive2-cloud-gateway/api/v1/live/interact/paas/getRoomStatusInfo/${roomId}`),
  getGroupList: (roomId) => Promise.resolve({}),
  getStudentList: (params) => Promise.resolve({}),
  getHistoryChatList: (params) => Promise.resolve({}),
  getHistoryQAList: (params) => Promise.resolve({}),
  getSeekHelpConfig: () => Promise.resolve({}),
  submitSeekHelp: (params) => Promise.resolve({}),
  applyFileTranscode: () => Promise.resolve({}),
  onTransCodeProgress: () => Promise.resolve({}),
  getOnlineUserCount: () => Promise.resolve({}),
  getTeacherList: () => Promise.resolve({}),
  uploadFile: () => Promise.resolve({}),
  getRoomAgilityStatusInfo: () => Promise.resolve({}),
  getUserAnswerList: () => Promise.resolve({}),
};
